import routes from "@/routes/routes";
import type { RouteConfig } from "@/types/routestypes";

export interface SidebarItem {
  id: string;
  path: string;
  icon?: string | React.ReactNode;
  pageName: string;
  permission?: string[];
  children?: SidebarItem[];
}

export const sideBarNavigation: SidebarItem[] = Object.entries(
  routes.privateRoutes as Record<string, RouteConfig>,
)
  .filter(
    ([, page]) =>
      page.sidebar?.show ||
      (page.children &&
        Object.values(page.children).some(
          (child) => child.sidebar?.show
        )),
  )
  .map(([key, pageData]) => {
    const rootPath = pageData.path.startsWith("/")
      ? pageData.path
      : `/${pageData.path}`;

    const data: SidebarItem = {
      id: key,
      path: rootPath,
      icon: pageData.sidebar?.icon,
      pageName: pageData.pageName ?? "Untitled",
      permission: pageData.permission
        ? Array.isArray(pageData.permission)
          ? pageData.permission
          : [pageData.permission]
        : [],
    };

    if (pageData.children) {
      data.children = mapChildren(pageData.children, data.id, rootPath);
    }

    return data;
  });

function mapChildren(
  children: Record<string, RouteConfig>,
  parentId: string,
  parentPath: string,
): SidebarItem[] {
  return Object.entries(children)
    .filter(
      ([, child]) =>
        child.sidebar?.show ||
        (child.children &&
          Object.values(child.children).some((nested) => nested.sidebar?.show)),
    )
    .map(([key, child]) => {
      const fullPath = parentPath
        ? `${parentPath}/${child.path}`.replace(/\/+/g, "/")
        : `/${child.path}`;

      const id = `${parentId}-${key}`;

      const mappedChild: SidebarItem = {
        id,
        path: fullPath,
        icon: child.sidebar?.icon,
        pageName: child.pageName ?? "Untitled",
        permission: child.permission
          ? Array.isArray(child.permission)
            ? child.permission
            : [child.permission]
          : [],
      };

      if (child.children) {
        mappedChild.children = mapChildren(child.children, id, fullPath);
      }

      return mappedChild;
    });
}
